import { render, staticRenderFns } from "./SettingTableColumns.vue?vue&type=template&id=65a26ff6&scoped=true&"
import script from "./SettingTableColumns.vue?vue&type=script&lang=js&"
export * from "./SettingTableColumns.vue?vue&type=script&lang=js&"
import style0 from "./SettingTableColumns.vue?vue&type=style&index=0&id=65a26ff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a26ff6",
  null
  
)

export default component.exports